module.exports = "pegasus/assets/themelp1/basic/102.png";